document.addEventListener("DOMContentLoaded", function () {

    /*
     * ==========================================
     * ALLOWED DELIVERY POSTCODES
     * ==========================================
     */

    const allowedPostcodes = [
        "2000",
        "2007",
        "2009",
        "2010",
        "2011",
        "2015",
        "2016",
        "2017",
        "2018",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2031",
        "2032",
        "2033",
        "2034",
        "2037",
        "2039",
        "2040",
        "2041",
        "2042",
        "2043",
        "2044",
        "2045",
        "2046",
        "2047",
        "2048",
        "2049",
        "2050",
        "2060",
        "2061",
        "2062",
        "2063",
        "2064",
        "2065",
        "2068",
        "2089",
        "2090",
        "2110",
        "2111",
        "2204"
    ];


    /*
     * ==========================================
     * GET FIELDS
     * ==========================================
     */

    const address = document.getElementById("deliveryAddress");
    const suburb = document.getElementById("deliverySuburb");
    const postcode = document.getElementById("deliveryPostcode");

    const deliveryDate = document.getElementById("deliveryDate");
    const deliveryTime = document.getElementById("deliveryTime");
    const deliveryInstructions = document.getElementById("deliveryInstructions");

    const schedule = document.getElementById("deliverySchedule");
    const validationMessage = document.getElementById("deliveryValidationMessage");


    /*
     * ==========================================
     * FIELDS TO SAVE
     * ==========================================
     */

    const fields = [
        "deliveryAddress",
        "deliverySuburb",
        "deliveryPostcode",
        "deliveryDate",
        "deliveryTime",
        "deliveryInstructions"
    ];


    /*
     * ==========================================
     * SAVE DELIVERY DETAILS
     * ==========================================
     */

    function saveDeliveryDetails() {

        let attributes = {};

        fields.forEach(function (fieldID) {

            const element = document.getElementById(fieldID);

            if (!element) {
                return;
            }

            const name = element.getAttribute("name");

            if (!name) {
                return;
            }

            const key = name
                .replace("attributes[", "")
                .replace("]", "");

            attributes[key] = element.value;

        });


        fetch("/cart/update.js", {

            method: "POST",

            headers: {
                "Content-Type": "application/json"
            },

            body: JSON.stringify({
                attributes: attributes
            })

        })

        .then(function (response) {

            return response.json();

        })

        .then(function () {

            console.log("Delivery details saved.");

        })

        .catch(function (error) {

            console.error(
                "Error saving delivery details:",
                error
            );

        });

    }


    /*
     * ==========================================
     * SHOW DELIVERY SCHEDULE
     * ==========================================
     */

    function showDeliverySchedule() {

        if (schedule) {

            schedule.style.display = "block";

        }

    }


    /*
     * ==========================================
     * HIDE DELIVERY SCHEDULE
     * ==========================================
     */

    function hideDeliverySchedule() {

        if (schedule) {

            schedule.style.display = "none";

        }

    }


    /*
     * ==========================================
     * DELIVERY DATE CALENDAR
     * ==========================================
     */

    function initializeCalendar() {

        if (!deliveryDate) {

            return;

        }

        if (typeof flatpickr === "undefined") {

            console.error(
                "Flatpickr is not loaded."
            );

            return;

        }


        /*
         * Prevent creating multiple calendars
         */

        if (deliveryDate._flatpickr) {

            return;

        }


        flatpickr(deliveryDate, {

            dateFormat: "d/m/Y",

            minDate: "today",

            disableMobile: true,

            clickOpens: true,

            allowInput: false,

            onChange: function (selectedDates, dateStr) {

                deliveryDate.value = dateStr;

                saveDeliveryDetails();

            }

        });

    }


    /*
     * ==========================================
     * VALIDATE POSTCODE
     * ==========================================
     */

    function validatePostcode() {

        if (!postcode) {

            return false;

        }

        const postcodeValue = postcode.value.trim();


        /*
         * EMPTY
         */

        if (postcodeValue === "") {

            if (validationMessage) {

                validationMessage.innerHTML =
                    "Please enter your delivery postcode.";

                validationMessage.style.color = "red";

            }

            hideDeliverySchedule();

            return false;

        }


        /*
         * MUST BE 4 DIGITS
         */

        if (!/^\d{4}$/.test(postcodeValue)) {

            if (validationMessage) {

                validationMessage.innerHTML =
                    "Please enter a valid 4-digit postcode.";

                validationMessage.style.color = "red";

            }

            hideDeliverySchedule();

            return false;

        }


        /*
         * CHECK ALLOWED POSTCODE
         */

        if (!allowedPostcodes.includes(postcodeValue)) {

            if (validationMessage) {

                validationMessage.innerHTML =
                    "❌ Sorry, we don't currently deliver to this postcode.";

                validationMessage.style.color = "red";

            }

            hideDeliverySchedule();

            return false;

        }


        /*
         * VALID POSTCODE
         */

        if (validationMessage) {

            validationMessage.innerHTML =
                "✅ Delivery is available to this postcode.";

            validationMessage.style.color = "green";

        }

        showDeliverySchedule();

        /*
         * Make sure calendar exists
         */

        initializeCalendar();

        /*
         * Save postcode
         */

        saveDeliveryDetails();

        return true;

    }


    /*
     * ==========================================
     * POSTCODE INPUT
     * ==========================================
     */

    if (postcode) {

        postcode.addEventListener("input", function () {

            /*
             * Numbers only
             */

            this.value = this.value.replace(/\D/g, "");


            /*
             * Maximum 4 digits
             */

            if (this.value.length > 4) {

                this.value =
                    this.value.substring(0, 4);

            }


            /*
             * Validate when 4 digits entered
             */

            if (this.value.length === 4) {

                validatePostcode();

            } else {

                hideDeliverySchedule();

                if (validationMessage) {

                    validationMessage.innerHTML = "";

                }

            }

        });


        /*
         * Validate when leaving postcode field
         */

        postcode.addEventListener("blur", function () {

            validatePostcode();

        });

    }


    /*
     * ==========================================
     * SAVE OTHER DELIVERY FIELDS
     * ==========================================
     */

    fields.forEach(function (fieldID) {

        const field =
            document.getElementById(fieldID);

        if (!field) {

            return;

        }


        /*
         * DATE / TIME / INSTRUCTIONS
         */

        if (
            fieldID === "deliveryDate" ||
            fieldID === "deliveryTime" ||
            fieldID === "deliveryInstructions"
        ) {

            field.addEventListener(
                "change",
                function () {

                    if (
                        postcode &&
                        allowedPostcodes.includes(
                            postcode.value.trim()
                        )
                    ) {

                        saveDeliveryDetails();

                    }

                }
            );


            field.addEventListener(
                "keyup",
                function () {

                    if (
                        postcode &&
                        allowedPostcodes.includes(
                            postcode.value.trim()
                        )
                    ) {

                        saveDeliveryDetails();

                    }

                }
            );

        }


        /*
         * ADDRESS / SUBURB
         */

        else {

            field.addEventListener(
                "change",
                saveDeliveryDetails
            );


            field.addEventListener(
                "keyup",
                function () {

                    if (
                        fieldID !== "deliveryPostcode"
                    ) {

                        saveDeliveryDetails();

                    }

                }
            );

        }

    });


    /*
     * ==========================================
     * INITIAL PAGE LOAD
     * ==========================================
     */

    if (postcode) {

        const initialPostcode =
            postcode.value.trim();


        if (
            initialPostcode &&
            allowedPostcodes.includes(
                initialPostcode
            )
        ) {

            if (validationMessage) {

                validationMessage.innerHTML =
                    "✅ Delivery is available to this postcode.";

                validationMessage.style.color =
                    "green";

            }

            showDeliverySchedule();

            /*
             * Initialize calendar
             */

            initializeCalendar();

        } else {

            hideDeliverySchedule();

        }

    }


    /*
     * ==========================================
     * FALLBACK: WAIT FOR FLATPICKR
     * ==========================================
     *
     * This handles cases where Flatpickr loads
     * slightly after this JavaScript file.
     *
     */

    if (
        deliveryDate &&
        typeof flatpickr === "undefined"
    ) {

        let attempts = 0;

        const calendarTimer =
            setInterval(function () {

                attempts++;

                if (
                    typeof flatpickr !== "undefined"
                ) {

                    clearInterval(
                        calendarTimer
                    );

                    if (
                        postcode &&
                        allowedPostcodes.includes(
                            postcode.value.trim()
                        )
                    ) {

                        initializeCalendar();

                    }

                }


                /*
                 * Stop checking after 5 seconds
                 */

                if (attempts >= 50) {

                    clearInterval(
                        calendarTimer
                    );

                    console.error(
                        "Flatpickr could not be loaded."
                    );

                }

            }, 100);

    }

});